const useCarbonThemes = () => {
    const isDarkMode = false;

    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    return () => (isDarkMode ? 'g100' : 'g10');
};

export default useCarbonThemes;
